import { makeStyles } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { useEffect, useState } from "react";
import { Button, useMutation, useNotify } from "react-admin";
import { useFormState } from "react-final-form";
import { useHistory } from "react-router-dom";

interface IUpdateRoutePlanButton {
  isSaveLoading: (x: boolean) => void;
}

const useStyles = makeStyles({
  savePlanButton: {
    padding: "8px",
    float: "right",
    minWidth: "10px",
    "& .MuiButton-textSizeSmall": {
      padding: 0,
    },
    "& .MuiButton-label > .MuiSvgIcon-root": {
      fontSize: 25,
    },
  },
});

const UpdateRoutePlanButton = ({ isSaveLoading }: IUpdateRoutePlanButton) => {
  const [isDisable, setIsDisable] = useState<boolean>(true);

  const classes = useStyles();
  const { values } = useFormState();
  const notify = useNotify();
  const history = useHistory();

  useEffect(() => {
    if (values?.routePlan !== null) {
      if (
        values?.busScheduleId &&
        values?.nextEffectiveDate &&
        values.nextRoutePlan?.routes?.length > 0
      ) {
        setIsDisable(false);
      } else {
        setIsDisable(true);
      }
    } else {
      if (values?.busScheduleId && values.nextRoutePlan?.routes?.length > 0) {
        setIsDisable(false);
      } else {
        setIsDisable(true);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  const [saveRoutePlan, { loading }] = useMutation(
    {
      type: "update",
      resource: "busSchedulePlans",
      payload: {
        id: values.id,
        data: {
          id: values.id,
          nextEffectiveDate: values.nextEffectiveDate,
          nextRoutePlan: {
            id: values.nextRoutePlan?.id,
            status: values.nextRoutePlan?.status,
            routes: values.nextRoutePlan?.routes.map((route: any) => {
              const tmpRoute: any = {
                id: route.id ? route.id : 0,
                name: route.name,
                busBayNumber: route.busBayNumber,
                startTime: route.startTime,
                endTime: route.endTime,
                driverId: route.driverId,
                busAssistantId: route.busAssistantId,
                vehicleId: route.vehicleId,
                backupDriverIds: route.backupDriverIds
                  ? route.backupDriverIds
                  : route.backupDrivers?.length > 0
                  ? route.backupDrivers.map(
                      (backupDriver: any) => backupDriver.id
                    )
                  : [],
                backupVehicleIds: route.backupVehicleIds
                  ? route.backupVehicleIds
                  : route.backupVehicles?.length > 0
                  ? route.backupVehicles.map(
                      (backupVehicle: any) => backupVehicle.id
                    )
                  : [],
                backupBusAssistantIds: route.backupBusAssistantIds
                  ? route.backupBusAssistantIds
                  : route.backupBusAssistants?.length > 0
                  ? route.backupBusAssistants.map(
                      (backupBA: any) => backupBA.id
                    )
                  : [],
                routeLocations: route.routeLocations.map((location: any) => {
                  const tmpLocation: any = {
                    id: location.id ? location.id : 0,
                    street: location.street,
                    unitNumber: location.unitNumber,
                    blockNumber: location.blockNumber,
                    building: location.building,
                    address: location.address,
                    postalCode: location.postalCode,
                    lat: location.lat,
                    lng: location.lng,
                    arrivedAt: location.arrivedAt
                      ? location.arrivedAt
                      : "00:00",
                    remark: location.remark,
                    order: location.order ? location.order : 1,
                    studentIds: location.students.map((student: IStudent) => {
                      return student.id;
                    }),
                  };

                  return tmpLocation;
                }),
              };

              return tmpRoute;
            }),
          },
        },
      },
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully update the route plan.`, "info");
        history.push("/busSchedulePlans");
      },
      onFailure: (error) => {
        notify(
          `Failed update the route plan, error: ${error.message}`,
          "warning"
        );
      },
    }
  );

  useEffect(() => {
    isSaveLoading(loading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return (
    <Button
      className={classes.savePlanButton}
      onClick={saveRoutePlan}
      disabled={isDisable}
    >
      <SaveIcon />
    </Button>
  );
};

export default UpdateRoutePlanButton;
